export const isDraftMode = (draftMode: boolean) => {
  return draftMode || process.env.NODE_ENV !== "production"
}
